import { DisputeTypes } from "utils/constants";
import { FrontOfficeDisputes } from "./disputes";

export function FrontOfficeAgentDisputes() {
  return <FrontOfficeDisputes disputeType={DisputeTypes.AgentDisputes} />;
}
